import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20composition%20with%20flowing%20golden%20and%20amber%20gradients%2C%20Chinese%20ink%20wash%20painting%20inspired%20textures%2C%20soft%20atmospheric%20layers%2C%20cultural%20elegance%2C%20modern%20minimal%20aesthetic%2C%20ethereal%20light%20beams%2C%20creative%20background%20for%20content%20platform&width=1600&height=900&seq=hero-gcq-01&orientation=landscape"
          alt="国产区精选内容聚合平台 - 汇聚海量优质国产原创内容"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <i className="ri-sparkling-2-line text-primary-400 text-sm"></i>
          <span className="text-xs text-background-50/90 whitespace-nowrap">每日精选 · 国产原创内容聚合</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4">
          发现国产原创的
          <span className="text-primary-400">无限可能</span>
        </h1>
        <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto leading-relaxed mb-10">
          国产区汇聚海量优质国产原创内容，覆盖影视精选、文学创作、音乐之声、视觉艺术等八大分类，
          为您提供最全面的国产区资源导航与分类推荐，一站式探索本土创作精华。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/film-tv"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-compass-3-line mr-2"></i>
            开始探索
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block p-4 rounded-xl bg-background-50/8 backdrop-blur-sm border border-background-50/10 hover:bg-background-50/15 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-2">
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-500/20 text-accent-300 whitespace-nowrap">
                  {article.category}
                </span>
              </div>
              <h3 className="text-sm font-medium text-background-50/90 text-left group-hover:text-primary-300 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-xs text-background-50/50 mt-2 line-clamp-1 text-left">
                {article.author} · {article.publishDate}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}